export enum RelayLogType {
  ClaimSent = 'ClaimSent',
  ClaimReceived = 'ClaimReceived',
  ReversalSent = 'ReversalSent',
  ReversalReceived = 'ReversalReceived',
}
